<template>
  <div :key="'chat-message-list'">
    <li class="cursor-pointer email__mail-item" v-for="(message, index) in messages"
      :key="String(message.id)" :style="{transitionDelay: (index * 0.1) + 's'}">
      <MessageListItem :index="index" :message="message" :isSelected="false">
        <MessageHeader :message="message" />
      </MessageListItem>
    </li>
  </div>
</template>

<script>
import { state } from "../../data";
import MessageListItem from "../MessageListItem";

export default {
  components: {
    MessageListItem,
    MessageHeader: () => import("./MessageHeader.vue")
  },
  data() {
    return {
      localData: state.local
    }
  },
  watch: {
    'localData.activeListType'(type) {
      alert(type);
    }
  },
  computed: {
    messages() {
      return this.localData.messagePool["chat"]
    }
  }
}
</script>
